import axios from 'axios';
import { BASE_URL, OAUTH_CLIENT_ID, OAUTH_DOMAIN } from '@/assets/js/config';
import { getAccessToken } from '@/assets/js/auth';
import { getIdToken } from '../auth';

export const getUser = async () => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`${BASE_URL}/api/current-user`, settings);
}

export const getIdpTokens = async (code, refreshToken) => {
  let url = false;
  let clientId = OAUTH_CLIENT_ID;

  if (code) {
    let grantType = 'authorization_code';
    let redirectUri =  BASE_URL + '/post-login';
    let codeVerifier = localStorage.getItem('codeVerifier');
    url = `${ OAUTH_DOMAIN }/oauth/v2/token?client_id=${ clientId }&grant_type=${ grantType }&code=${ code }&code_verifier=${ codeVerifier }&redirect_uri=${ redirectUri }`;
  } else if (refreshToken) {
    let grantType = 'refresh_token';
    url = `${ OAUTH_DOMAIN }/oauth/v2/token?client_id=${ clientId }&grant_type=${ grantType }&refresh_token=${ refreshToken }`;
  }

  return axios.get(url);
}

export const updateIdpProfile = async (data) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.put(`${ OAUTH_DOMAIN }/auth/v1/users/me/profile`, data, settings);
}


export const getUserInfo = async () => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`${ OAUTH_DOMAIN }/oidc/v1/userinfo`, settings);
}

const createUser = async () => {
  const idToken = getIdToken();
  const body = { 'id_token': idToken };
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.post(`${BASE_URL}/api/current-user`, body, settings);
}

export const updateUser = async (data) => {
  const idToken = getIdToken();
  const body = { 'id_token': idToken };

  if (data !== undefined) {
      if (data.first_name || data.last_name) {
          body.first_name = data.first_name;
          body.last_name = data.last_name;
      }
      if (data.knowledge) {
          body.knowledge = data.knowledge
      }
      if (data.phone_number) {
          body.phone_number = data.phone_number
      }
  }
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.patch(`${BASE_URL}/api/current-user`, body, settings);
}

export const updateKnowledge = async (data) => {
  const body = data;
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.patch(`${BASE_URL}/api/current-user/knowledge`, data, settings);
}

export const updateLanguage = async (data) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.patch(`${BASE_URL}/api/current-user/prefered-language`, data, settings);
}

export const deleteUser = async () => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.delete(`${BASE_URL}/api/current-user`, settings);
}

export const createOrUpdateUser = async () => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    },
    validateStatus: (status) => {
      let statusInNormalRange = (status >= 200 && status < 300);
      let statusNotFound = status === 404;

      if (statusInNormalRange || statusNotFound) {
        return true;
      }
      return false;
    }
  };

  return axios.get(`${BASE_URL}/api/current-user`, settings)
  .then((response) => {
      if (response.status === 404) {
          createUser();
      } else {
          updateUser();
      }
  })
  .catch((error) => {
    console.error(error);
  });
}

export const updateUserEmail = async (data) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.patch(`${BASE_URL}/api/current-user/email`, data, settings);
}

export const changePassword = async (data) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.put(`${ OAUTH_DOMAIN }/auth/v1/users/me/password`, data, settings);
}

export const changeActiveProject = async (projectData) => {
    let data = '';
    if (projectData) {
        data = projectData;
    } else {
      data = {"emk_namespace": null}
    }
    if (Object.keys(projectData).length === 0) {
      data = {
        'current_os_project': false,
        'current_emk_project': false
      }
    }

    const settings = {
        headers: {
            'Authorization': `Bearer ${getAccessToken()}`
        }
    };

    return axios.patch(`${BASE_URL}/api/current-user/current-project`, data, settings);
}

export const blockUser = async () => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.post(`${BASE_URL}/api/current-user/block`, null, settings);
}

export const getOsUser = async () => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`${BASE_URL}/api/current-user/os`, settings);
}

export const getEmkToken = async () => {
  const settings = {
      headers: {
          'Authorization': `Bearer ${getAccessToken()}`
      }
  };

  return axios.post(`${BASE_URL}/api/current-user/emk-exchange`, {}, settings);
}